import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import RHService from '../../../../services/rh';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [ano, setAno] = useState("");
    const [orgao, setOrgao] = useState("");
    const [anoArq, setAnoArq] = useState("");
    const [referencia, setReferencia] = useState("");

    const busca = async (query) => {
        if (query === "") {
            await props.fetchConcursos()
            setAno("")
            setOrgao("")
            setReferencia("")
            setAnoArq("")
        } else {
            var response = await RHService.buscarConcurso(query)
            if (response.data.length >= 1) {
                props.setConcursos(response.data)
                props.setVazio(false)
                setAno("")
                setOrgao("")
                setReferencia("")
                setAnoArq("")
            } else {
                props.setVazio(true)
                setAno("")
                setOrgao("")
                setReferencia("")
                setAnoArq("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (ano) prepQuery = prepQuery + `ano=${ano}`;
        if (orgao !== "false" && orgao !== "") prepQuery = prepQuery + `&orgao=${encodeURI(orgao)}`;
        if (referencia !== "false" && referencia !== "") prepQuery = prepQuery + `&referencia=${encodeURI(referencia)}`;
        if (anoArq) prepQuery = prepQuery + `&anoArq=${anoArq}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano do Concurso"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="orgao">
                                <FloatingLabel
                                    label="Órgão"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="orgao"
                                        name="orgao"
                                        onChange={e => setOrgao(e.target.value)}
                                    >
                                        <option>TODOS</option>
                                        <option value="Prefeitura Municipal de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Secretaria Municipal de Saúde">Secretaria Municipal de Saúde</option>
                                        <option value="Secretaria Municipal de Educação">Secretaria Municipal de Educação</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                         <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="referencia">
                                <FloatingLabel
                                    label="Tipo de Edital"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="referencia"
                                        name="referencia"
                                        onChange={e => setReferencia(e.target.value)}
                                    >
                                        <option>TODOS</option>
                                        <option value="Edital de Abertura">Edital de Abertura</option>
                                        <option value="Edital de Convocação">Edital de Convocação</option>
                                        <option value="Resultado Final">Resultado Final</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano do Edital de Convocação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={anoArq}
                                        onChange={e => setAnoArq(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/folha/concursos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.concursos} nome={"Concursos"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#a7b26d4c-5db5-4991-b9e5-43f269c0d0c5" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca